/**
 * @generated SignedSource<<246f3a8ff703a2125aa1c8cd8f820104>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeletePayslipInput = {
  clientMutationId?: string | null | undefined;
  payslipId: string;
};
export type DeletePayslipMutation$variables = {
  connections: ReadonlyArray<string>;
  input: DeletePayslipInput;
};
export type DeletePayslipMutation$data = {
  readonly deletePayslip: {
    readonly deletedPayslipId: string | null | undefined;
    readonly errors: any | null | undefined;
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type DeletePayslipMutation = {
  response: DeletePayslipMutation$data;
  variables: DeletePayslipMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedPayslipId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeletePayslipMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeletePayslipPayload",
        "kind": "LinkedField",
        "name": "deletePayslip",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeletePayslipMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeletePayslipPayload",
        "kind": "LinkedField",
        "name": "deletePayslip",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedPayslipId",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3341cc9fd6a04c39a69ef33a8f213404",
    "id": null,
    "metadata": {},
    "name": "DeletePayslipMutation",
    "operationKind": "mutation",
    "text": "mutation DeletePayslipMutation(\n  $input: DeletePayslipInput!\n) {\n  deletePayslip(input: $input) {\n    success\n    errors\n    deletedPayslipId\n  }\n}\n"
  }
};
})();

(node as any).hash = "c58005cab8fb0b35bdce3033533ff3ec";

export default node;
